document.addEventListener('DOMContentLoaded', function() {
  var filterBlocks = document.querySelectorAll('.filter-block-btn');
  if (!filterBlocks.length) {

    return;
  }


  filterBlocks.forEach(function(btn) {
    if (btn.classList.contains('disabled')) return;
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var url = btn.getAttribute('href');
      if (url) {
        window.location.href = url;
      }
    });
  });
});
